import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/srv/www/uia-frontend/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/srv/www/uia-frontend/layouts/default.vue").then(m => m.default || m)),
  irol: defineAsyncComponent(() => import("/srv/www/uia-frontend/layouts/irol.vue").then(m => m.default || m)),
  private: defineAsyncComponent(() => import("/srv/www/uia-frontend/layouts/private.vue").then(m => m.default || m))
}